import * as ActionType from '../constants/constant_action_types';

const INITIAL_STATE = null;

export function pathReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionType.SET_CURRENT_PATH: {
      return action.path;
    }
    default:
      return state;
  }
}